module.exports = __webpack_public_path__ + "static/media/mic.40b0ab56.svg";